import { action } from 'satcheljs';

/**
 * action for changing the useDesktopSignature property in the active view state
 * @param newValue : boolean which suggests the new value to be added
 * We can avoid this param, but we send it explicitly to ensure aversion of a race condition
 * Is a public action
 */
const changeUseDesktopSignature = action('changeUseDesktopSignature', (newValue: boolean) => ({
    newValue,
}));

export default changeUseDesktopSignature;
